import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TemplateInput } from '@amzn/mulberry-internal-typescript-client';

export interface TemplateState {
  template: TemplateInput | null;
  loading: boolean;
  error?: string;
}

const initialState: TemplateState = {
  template: null,
  loading: false,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplate: (state, action: PayloadAction<TemplateInput>) => {
      state.template = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    setTemplateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTemplateError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearTemplate: () => initialState,
  },
});

export const { setTemplate, setTemplateLoading, setTemplateError, clearTemplate } =
  templateSlice.actions;

export const selectTemplate = (state: { template: TemplateState }) => state.template.template;
export const selectTemplateLoading = (state: { template: TemplateState }) => state.template.loading;
export const selectTemplateError = (state: { template: TemplateState }) => state.template.error;

export default templateSlice.reducer;
